const SourceEnum = Object.freeze({
    SFCC: 'SalesForce',
    YOOX: 'Yoox',
    BESTSEC: 'BestSecret',
    TRADEBYTE: 'TradeByte',
    SPO: 'Spo',
    INSTORE: 'InstoreApp',
    RU_WEBSITE: 'RU Website',
    MOLIERA: 'Moliera'
});

export {SourceEnum}